import {
    CREATE_HUBSPOT_CONNECTION_FAILURE,
    CREATE_HUBSPOT_CONNECTION_SUCCESS,
    DELETE_HUBSPOT_CONNECTION_FAILURE,
    DELETE_HUBSPOT_CONNECTION_SUCCESS,
    GET_HUBSPOT_CONNECTION_FAILURE,
    GET_HUBSPOT_CONNECTION_SUCCESS,
    GET_HUBSPOT_OBJECTS_FAILURE,
    GET_HUBSPOT_OBJECTS_SUCCESS,
    GET_HUBSPOT_OBJECT_DESCRIBE_FAILURE,
    GET_HUBSPOT_OBJECT_DESCRIBE_SUCCESS,
    GET_HUBSPOT_OBJECT_PREVIEW_FAILURE,
    GET_HUBSPOT_OBJECT_PREVIEW_SUCCESS,
    START_HUBSPOT_OAUTH_FAILURE,
    START_HUBSPOT_OAUTH_SUCCESS,
    UPDATE_HUBSPOT_CONNECTION_FAILURE,
    UPDATE_HUBSPOT_CONNECTION_SUCCESS
} from "./actions";

const initialState = {
    createConnectionResult: {
        success: true
    },
    createdConnection: null,
    startOAuthResult: {
        success: true
    },
    getConnectionResult: {
        success: true
    },
    connection: null,
    updateConnectionResult: {
        success: true
    },
    deleteConnectionResult: {
        success: true
    },
    getHubspotObjectsResult: {
        success: true
    },
    hubspotObjects: null,
    getHubspotObjectDescribeResult: {
        success: true
    },
    hubspotObjectDescribe: null,
    getHubspotObjectPreviewResult: {
        success: true
    },
    hubspotObjectPreview: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CREATE_HUBSPOT_CONNECTION_SUCCESS:
            return { ...state, createConnectionResult: { success: true }, createdConnection: action.payload.connection };
        case CREATE_HUBSPOT_CONNECTION_FAILURE:
            return { ...state, createConnectionResult: { success: false, ...action.payload.error }, createdConnection: null };
        case START_HUBSPOT_OAUTH_SUCCESS:
            return { ...state, startOAuthResult: { success: true, ...action.payload.result } };
        case START_HUBSPOT_OAUTH_FAILURE:
            return { ...state, startOAuthResult: { success: false, ...action.payload.error } };
        case GET_HUBSPOT_CONNECTION_SUCCESS:
            return { ...state, getConnectionResult: { success: true }, connection: action.payload.connection };
        case GET_HUBSPOT_CONNECTION_FAILURE:
            return { ...state, getConnectionResult: { success: false, ...action.payload.error }, connection: null };
        case UPDATE_HUBSPOT_CONNECTION_SUCCESS:
            return { ...state, updateConnectionResult: { success: true } };
        case UPDATE_HUBSPOT_CONNECTION_FAILURE:
            return { ...state, updateConnectionResult: { success: false, ...action.payload.error } };
        case DELETE_HUBSPOT_CONNECTION_SUCCESS:
            return { ...state, deleteConnectionResult: { success: true } };
        case DELETE_HUBSPOT_CONNECTION_FAILURE:
            return { ...state, deleteConnectionResult: { success: false, ...action.payload.error } };
        case GET_HUBSPOT_OBJECTS_SUCCESS:
            return { ...state, getHubspotObjectsResult: { success: true }, hubspotObjects: action.payload.objects };
        case GET_HUBSPOT_OBJECTS_FAILURE:
            return { ...state, getHubspotObjectsResult: { success: false, ...action.payload.error }, hubspotObjects: null };
        case GET_HUBSPOT_OBJECT_DESCRIBE_SUCCESS:
            return { ...state, getHubspotObjectDescribeResult: { success: true }, hubspotObjectDescribe: action.payload.describe };
        case GET_HUBSPOT_OBJECT_DESCRIBE_FAILURE:
            return { ...state, getHubspotObjectDescribeResult: { success: false, ...action.payload.error }, hubspotObjectDescribe: null };
        case GET_HUBSPOT_OBJECT_PREVIEW_SUCCESS:
            return { ...state, getHubspotObjectPreviewResult: { success: true }, hubspotObjectPreview: action.payload.preview };
        case GET_HUBSPOT_OBJECT_PREVIEW_FAILURE:
            return { ...state, getHubspotObjectPreviewResult: { success: false, ...action.payload.error }, hubspotObjectPreview: null };
        default:
            return state;
    }
};
